import React from "react";
import "../style/Header.scss";

const Header = (prop) => {
  const { text } = prop;

  return (
    <div className="header-box">
      <div className="title">
        <span>장애, 테크를 만나다</span>
      </div>
      <div className="headline">
        <span> {text} </span>
      </div>
    </div>
  );
};

export default Header;
